---
en:
  asset_comments:
    create_title: Create new asset comment
    overlap_current_month: Overlapping comment for current month in current year
    overlap_current_quarter: Overlapping comment for current quarter in current year
    overlap_current_year: Overlapping comment for current year
    title: Asset comments
